import apiFetch from './client';
import type { MeResponse } from './user';

export interface CreateFirebaseUserPayload {
  email: string;
  password: string;
  displayName?: string;
}

export const provisionUser = () =>
  apiFetch<MeResponse>('/accounts/provision', { method: 'POST' });

export async function createFirebaseUser(
  payload: CreateFirebaseUserPayload,
): Promise<{ uid: string }> {
  return apiFetch<{ uid: string }>('/accounts/create-firebase-user', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
